import React from "react";
import { Typography, Box, Chip, Button } from "@mui/material";
import WhyUsCard from "./WhyUsCard";
import { logout, useSiteState } from "../hookState/SiteState";
import { useNavigate } from "react-router-dom";
import { setProfileState } from "../hookState/ProfileState";
import RouteConstants from "../constants/RouteConstant";
import First from "../assets/whyus/1.png";
import Second from "../assets/whyus/2.png";
import Third from "../assets/whyus/3.png";

export const WhyUs = () => {
	const state = useSiteState();
	const navigate = useNavigate();
	const handleRedirect = (val) => {
		setProfileState(false);
		if (val === "login") {
			navigate(RouteConstants.LOGIN);
		} else {
			logout();
			navigate(RouteConstants.LANDING);
		}
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				width: { xs: "305px", md: "1280px" },
				zIndex: 3,
				// p: "20px 20px",
				gap: 4,
				background: "#fff",
				justifyContent: "center",
				alignItems: "center",
				alignSelf: "center",
				alignContent: "center",
				py: 2,
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignContent: "center",
					textAlign: "center",
					alignItems: "center",
				}}
			>
				<Chip
					label="Why Us"
					variant="filled"
					sx={{
						borderRadius: 4,
						fontSize: "18px",
						color: "#667085",
						width: "200px",
					}}
				/>
			</Box>

			<Box
				sx={{
					display: "flex",
					flexDirection: { xs: "column", md: "row" },
					justifyContent: "space-between",
					p: "20px 20px",
					width: { xs: "305px", md: "1280px" },
					alignItems: "center",
					alignContent: "center",
					alignSelf: "center",
				}}
			>
				<Box>
					<Typography
						fontWeight={600}
						fontSize={{ xs: 35, md: 48 }}
						color="#000000"
					>
						{"Why Choose Ecom Insider?"}
					</Typography>
					<Typography
						fontWeight={400}
						fontSize={{ xs: 15, md: 18 }}
						color="#667085"
					>
						{
							"We take the guesswork out of eCommerce, saving you time and money while "
						}
					</Typography>
					<Typography
						fontWeight={400}
						fontSize={{ xs: 15, md: 18 }}
						color="#667085"
					>
						{"giving you the best tools to succeed effortlessly."}
					</Typography>
				</Box>
				{state.user.get() === "" && (
					<Button
						color="secondary"
						// sx={{ }}
						onClick={() => handleRedirect("login")}
						sx={{
							display: { xs: "none", md: "block" },
							alignItems: "center",
							justifyContent: "center",
							my: "auto",
							color: "primary.main",
							bgcolor: "tertiary.main",
							px: { xs: 0, md: 2 },
							// mx: { xs: "-5px" },
							borderRadius: 8,
							height: { xs: "23px", md: "32px" },
							minWidth: "46px",
							// width: { xs: "20px" },
						}}
					>
						<Typography
							color={"primary.main"}
							textTransform={"capitalize"}
							fontSize={{ xs: 12, md: 14 }}
							fontWeight={600}
						>
							Log In
						</Typography>
					</Button>
				)}
			</Box>

			<Box
				sx={{
					display: "flex",
					flexDirection: { xs: "column", md: "row" },
					justifyContent: "center",
					gap: { xs: 1, md: 2 },
				}}
			>
				{/* {[1, 2, 3].map(() => {
					return <WhyUsCard description />;
				})} */}
				<WhyUsCard
					description={
						"Ecom Insider saves you hours of research by delivering handpicked, data-backed product reports straight to your dashboard. No more endless scrolling or second-guessing—just instant access to what’s hot and what sells. We do the digging, so you can focus on scaling fast and cashing in quicker!"
					}
					image={First}
					title={"Save time. Time = Money"}
				/>
				<WhyUsCard
					description={
						"Ecom Insider slashes your risk by providing data-driven product picks. Say goodbye to costly flops and blind guesses—our insights are built on real trends and performance, not hype. Confidently launch products that convert and start your journey today!"
					}
					image={Second}
					title={"Save money. Reduce your risk! "}
				/>
				<WhyUsCard
					description={
						"Ecom Insider keeps you steps ahead of the competition with real-time trend tracking for winning products. While others chase yesterday’s hits, you’ll be first to market with tomorrow’s bestsellers. Stay sharp, move fast, and ride every wave before it breaks—because in eCom, timing is everything!"
					}
					image={Third}
					title={"Stay ahead. Stay informed"}
				/>
			</Box>
		</Box>
	);
};
